import { OrderResponseApi } from '../services/angular/types/Order';
import { appState } from '../store/appState';

export const canCancelOrder = (order?: OrderResponseApi) =>
	order &&
	order?.statusId !== appState.orderStatus.Cancelado.id &&
	order?.statusId !== appState.orderStatus.Finalizado.id;
